import { render, staticRenderFns } from "./ObjectiveCard.vue?vue&type=template&id=1c45869c"
import script from "./ObjectiveCard.vue?vue&type=script&lang=js"
export * from "./ObjectiveCard.vue?vue&type=script&lang=js"
import style0 from "./ObjectiveCard.vue?vue&type=style&index=0&id=1c45869c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports